<template>
  <v-container>
    <v-card v-if="term">
      <v-card-text>
        <report-form
          :reportParameters="reportParameters"
          :reportOptions="reportOptions"
          :reportType="reportType"
          :reportId="reportId"
          :term="term"
        />
      </v-card-text>
    </v-card>
    <error-handler :error="error"></error-handler>
  </v-container>
</template>

<script>
import ReportForm from "@/components/UserReports/ReportForm.vue";
import { mapActions, mapGetters } from "vuex";
import AuthService from "@/services/auth.service";
import ErrorHandler from "../components/ErrorHandler";

export default {
  components: { ReportForm, ErrorHandler },
  props: ["reportId", "reportType", "planId"],
  methods: {
    ...mapActions("transactions", [
      "getEmailReport",
      "getUserReportsConfigurations",
    ]),
    ...mapActions("plansMembers", ["getPlanOptions", "getUserPlans"]),
    ...mapActions("auth", ["getUser", "silentRefresh", "login"]),
    ...mapActions("common", ["setPlan", "setPlans"]),
    async loadUserPlans() {
      const plansResponse = await this.getUserPlans();
      const plans = plansResponse.data.value.map((o) => {
        o.Name = o.Current.Name;
        o.Description = o.Current.Description;
        o.Translations = o.Current.Translations;
        return o;
      });
      this.setPlans(plans);
      let plan = plans.filter((o) => o.Id === this.planId);
      if (plan.length > 0) {
        this.setPlan(plan[0]);
        await this.getPlanOptions(plan[0].Id);
      } else {
        let error = new Error();
        error.customMessage = this.$t("views.emailcallback.user_missing_plan");
        this.error = error;
      }
    },
  },
  computed: {
    ...mapGetters("common", ["plan"]),
  },
  async mounted() {
    await this.loadUserPlans();
    const user = await AuthService.getUser();
    const userId = user.profile.sub;

    var res = await this.getEmailReport({
      plan: this.plan.Id,
      reportType: this.reportType,
      reportId: this.reportId
    });
    const item = res.data.value[0];

    res = await this.getUserReportsConfigurations({ userId });
    const userReportSettings = res.data.filter(
      (o) =>
        o.PlanId === this.plan.Id &&
        o.ReportParameters.ReportType === this.reportType
    );

    this.term = {
      Id: item.BillingTerm.Id,
      Name: item.BillingTerm.Name,
      Item: item,
    };

    if (userReportSettings.length > 0) {
      var params = userReportSettings[0].ReportParameters;
      this.reportOptions = params.Options;
      this.reportParameters = params;
    }
  },
  data() {
    return {
      reportOptions: [],
      reportParameters: {},
      term: null,
      error: null,
    };
  },
};
</script>
